import { Badge } from "@radix-ui/themes";
import { StageDetailStatus } from "@/shared/api/lod-api";
import { memo } from "react";
import { HoverDetailsButton } from "./hover-details-button";

const STAGE_STATUS = {
  NOT_STARTED: "not_started",
  DONE: "done",
  REJECTED: "rejected",
} as const;

type StageStatus = (typeof STAGE_STATUS)[keyof typeof STAGE_STATUS];

const getStageStatusColor = (status: StageStatus) => {
  switch (status) {
    case STAGE_STATUS.DONE:
      return "green";
    case STAGE_STATUS.REJECTED:
      return "red";
    case STAGE_STATUS.NOT_STARTED:
    default:
      return "gray";
  }
};

const formatStageStatusText = (status: StageStatus): string => {
  switch (status) {
    case STAGE_STATUS.DONE:
      return "Done";
    case STAGE_STATUS.REJECTED:
      return "Rejected";
    case STAGE_STATUS.NOT_STARTED:
    default:
      return "Not Started";
  }
};

interface StageCellProps {
  stageStatus?: StageDetailStatus;
  availableStatuses?: string[];
  onDetailsClick?: () => void;
}

const StageCellComponent = ({
  stageStatus,
  availableStatuses,
  onDetailsClick,
}: StageCellProps) => {
  const currentStatus =
    (stageStatus?.status as StageStatus) || STAGE_STATUS.NOT_STARTED;

  const statusTextMap: Record<string, string> = {};
  if (availableStatuses) {
    availableStatuses.forEach((status) => {
      statusTextMap[status] = status
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    });
  }

  const displayText =
    statusTextMap[currentStatus] || formatStageStatusText(currentStatus);

  return (
    <>
      <Badge color={getStageStatusColor(currentStatus)} size="1">
        {displayText}
      </Badge>
      <HoverDetailsButton onClick={onDetailsClick} />
    </>
  );
};

export const StageCell = memo(StageCellComponent);
